import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-page')
export class MdcPage extends LitElement {
  @property({ type: Boolean }) centered = true
  @property({ attribute: 'contentwidth' }) contentWidth: 'narrow' | 'wide' = 'wide'

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		:host([contentwidth="narrow"]) {
			--container-max-width: 72rem;
		}

		.mdc-page-template {
			width: 100%;
		}

		.mdc-page-template__content-wrapper {
			margin: 0 auto;
			max-width: var(--container-max-width, 1440px);
			padding: var(--spacing-page-gutter-sm, var(--spacing-100));
		}

		/* breakpoints.md */
		@media (min-width: 768px) {
			.mdc-page-template__content-wrapper {
				padding: var(--spacing-page-gutter-md, var(--spacing-150));
			}
		}

		/* breakpoints.xl */
		@media (min-width: 1280px) {
			.mdc-page-template__content-wrapper {
				padding: var(--spacing-page-gutter-lg, var(--spacing-250));
			}
		}
	`

  render() {
    return html`
			<div class="mdc-page-template">
				${
          this.centered
            ? html`<div class="mdc-page-template__content-wrapper"><slot></slot></div>`
            : html`<slot></slot>`
        }
			</div>
		`
  }
}
